// Animated Horizontal Timeline - Le Rêve (ES Module)

document.addEventListener("DOMContentLoaded", () => {
     gsap.registerPlugin(ScrollTrigger);

     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     const stickySection = document.querySelector(".animated-timeline-sticky");
     if (!stickySection) return;
     
     // Get header element for transparency effect
     let header = document.querySelector('.site-header');
     const outlineCanvas = document.querySelector(".animated-timeline-outline-layer");
     const fillCanvas = document.querySelector(".animated-timeline-fill-layer");
     const outlineCtx = outlineCanvas.getContext("2d");
     const fillCtx = fillCanvas.getContext("2d");

     function setCanvasSize(canvas, ctx) {
          const dpr = window.devicePixelRatio || 1;
          canvas.width = window.innerWidth * dpr;
          canvas.height = window.innerHeight * dpr;
          canvas.style.width = `${window.innerWidth}px`;
          canvas.style.height = `${window.innerHeight}px`;
          ctx.scale(dpr, dpr);
     }
     setCanvasSize(outlineCanvas, outlineCtx);
     setCanvasSize(fillCanvas, fillCtx);

     const triangleSize = 150;
     const lineWidth = 1;
     const SCALE_THRESHOLD = 0.01;
     const triangleStates = new Map();
     let animationFrameId = null;
     let canvasXPosition = 0;

     function drawTriangle(ctx, x, y, fillScale = 0, flipped = false) {
          const halfSize = triangleSize / 2;

          if (fillScale < SCALE_THRESHOLD) {
               ctx.beginPath();
               if (!flipped) {
                    ctx.moveTo(x, y - halfSize);
                    ctx.lineTo(x + halfSize, y + halfSize);
                    ctx.lineTo(x - halfSize, y + halfSize);
               } else {
                    ctx.moveTo(x, y + halfSize);
                    ctx.lineTo(x + halfSize, y - halfSize);
                    ctx.lineTo(x - halfSize, y - halfSize);
               }
               ctx.closePath();
               // Use a subtle surface color for timeline animation strokes
               const surfaceColor = getComputedStyle(document.documentElement).getPropertyValue('--color-surface-primary').trim() || '#ffffff';
               ctx.strokeStyle = surfaceColor.replace('rgb', 'rgba').replace(')', ', 0.075)');
               ctx.lineWidth = lineWidth;
               ctx.stroke();
          }

          if (fillScale >= SCALE_THRESHOLD) {
               ctx.save();
               ctx.translate(x, y);
               ctx.scale(fillScale, fillScale);
               ctx.translate(-x, -y);

               ctx.beginPath();
               if (!flipped) {
                    ctx.moveTo(x, y - halfSize);
                    ctx.lineTo(x + halfSize, y + halfSize);
                    ctx.lineTo(x - halfSize, y + halfSize);
               } else {
                    ctx.moveTo(x, y + halfSize);
                    ctx.lineTo(x + halfSize, y - halfSize);
                    ctx.lineTo(x - halfSize, y - halfSize);
               }
               ctx.closePath();
               // Get theme-aware color for le reve triangle overlay
               const triangleColor = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary-accent').trim() || '#9332a8';
               ctx.fillStyle = triangleColor;
               ctx.strokeStyle = triangleColor;
               ctx.lineWidth = lineWidth;
               ctx.stroke();
               ctx.fill();
               ctx.restore();
          }
     }

     function drawGrid(scrollProgress = 0) {
          if (animationFrameId) {
               cancelAnimationFrame(animationFrameId);
          }

          outlineCtx.clearRect(0, 0, outlineCanvas.width, outlineCanvas.height);
          fillCtx.clearRect(0, 0, fillCanvas.width, fillCanvas.height);

          // Triangle animation starts after cards finish moving
          // Use dynamic timing if progressDivisor is defined, otherwise fallback to original value
          const triangleStartProgress = typeof progressDivisor !== 'undefined' ? progressDivisor : 0.38;
          const triangleDuration = 1 - triangleStartProgress;
          const animationProgress =
               scrollProgress <= triangleStartProgress ? 0 :
                    (scrollProgress - triangleStartProgress) / triangleDuration;

          let needsUpdate = false;
          const animationSpeed = 0.15;

          triangleStates.forEach((state, key) => {
               if (state.scale < 1) {
                    const x =
                         state.col * (triangleSize * 0.5) + triangleSize / 2 + canvasXPosition;
                    const y = state.row * triangleSize + triangleSize / 2;
                    const flipped = (state.row + state.col) % 2 !== 0;
                    drawTriangle(outlineCtx, x, y, 0, flipped);
               }
          });

          triangleStates.forEach((state, key) => {
               const shouldBeVisible = state.order <= animationProgress;
               const targetScale = shouldBeVisible ? 1 : 0;
               const newScale =
                    state.scale + (targetScale - state.scale) * animationSpeed;

               if (Math.abs(newScale - state.scale) > 0.001) {
                    state.scale = newScale;
                    needsUpdate = true;
               }

               if (state.scale >= SCALE_THRESHOLD) {
                    const x =
                         state.col * (triangleSize * 0.5) + triangleSize / 2 + canvasXPosition;
                    const y = state.row * triangleSize + triangleSize / 2;
                    const flipped = (state.row + state.col) % 2 !== 0;
                    drawTriangle(fillCtx, x, y, state.scale, flipped);
               }
          });

          if (needsUpdate) {
               animationFrameId = requestAnimationFrame(() => drawGrid(scrollProgress));
          }
     }

     function initializeTriangles() {
          const cols = Math.ceil(window.innerWidth / (triangleSize * 0.5));
          const rows = Math.ceil(window.innerHeight / (triangleSize * 0.5));
          const totalTriangles = rows * cols;

          const positions = [];
          for (let r = 0; r < rows; r++) {
               for (let c = 0; c < cols; c++) {
                    positions.push({ row: r, col: c, key: `${r}-${c}` });
               }
          }

          for (let i = positions.length - 1; i > 0; i--) {
               const j = Math.floor(Math.random() * (i + 1));
               [positions[i], positions[j]] = [positions[j], positions[i]];
          }

          positions.forEach((pos, index) => {
               triangleStates.set(pos.key, {
                    order: index / totalTriangles,
                    scale: 0,
                    row: pos.row,
                    col: pos.col,
               });
          });
     }

     let currentScrollTrigger = null;

     function initTimeline() {
          // Dynamic calculations based on number of cards
          const cards = document.querySelectorAll(".animated-timeline-card");
          const cardCount = cards.length;

          // 🎯 SALON DES RÊVES TIMELINE CONTROLS (viewport-based root solution)
          // Dynamic calculations based on actual viewport-to-content ratio
          const SCROLL_HEIGHT_BASE = 6;       // Original Salon des Rêves base
          const SCROLL_HEIGHT_SCALE = 0.8;   // Original Salon des Rêves scaling
          const PROGRESS_BASE = 0.42;        // Slightly slower for better ending animation timing
          const PROGRESS_SCALE = 0.035;      // Original Salon des Rêves scaling
          const WIDTH_BASE = 230;           // Match Le Rêve card width
          const WIDTH_SCALE = 47.5;         // Average of 45 and 50
          
          // Calculate scroll height for ScrollTrigger pinning
          // This controls how long the section stays pinned, NOT the horizontal scroll distance
          const scrollMultiplier = Math.min(cardCount * SCROLL_HEIGHT_SCALE, 9);
          const stickyHeight = window.innerHeight * (SCROLL_HEIGHT_BASE + scrollMultiplier);
          
          // For mobile, ensure adequate scroll distance by adjusting container width instead
          // The stickyHeight should be reasonable for ScrollTrigger to work properly

          // Calculate progress divisor (adjusts for card count)
          const progressAdjustment = Math.max(0.02, (10 - cardCount) * PROGRESS_SCALE);
          let progressDivisor = PROGRESS_BASE + progressAdjustment;

          // Adjust progress divisor for mobile screens with viewport-aware scaling
          const isMobile = window.innerWidth < 900;
          const isVerySmallMobile = window.innerWidth < 480;

          // More nuanced mobile adjustment based on actual viewport size
          let mobileProgressAdjustment = 1.0;
          if (isVerySmallMobile) {
               // On very small screens, moderate slowdown for ending animation
               mobileProgressAdjustment = 0.65; // Adjusted for new base timing
          } else if (isMobile) {
               // On regular mobile, slight slowdown
               mobileProgressAdjustment = 0.85; // Adjusted for new base timing
          }
          
          progressDivisor = progressDivisor * mobileProgressAdjustment;

          // FIXED SOLUTION: Calculate container width for proper ScrollTrigger + horizontal scrolling
          // Use a hybrid approach that ensures both pinning works and mobile has enough scroll distance

          // Base calculation that works with ScrollTrigger
          const baseWidthMultiplier = cardCount * 1.2; // Base multiplier for card count
          let containerWidthPercent = 400 + (baseWidthMultiplier * 50); // Start at 400%, add based on cards

          // For mobile devices, ensure adequate scroll distance for ending animation
          if (isVerySmallMobile) {
               // On very small screens, use even larger width for more scroll distance
               containerWidthPercent = Math.max(containerWidthPercent, 900); // Increased from 800% to 900%
               console.log('📱 Mobile container width fix:', {
                    baseWidthMultiplier,
                    containerWidthPercent: containerWidthPercent + '%',
                    reason: 'More scroll distance for ending animation'
               });
          } else if (isMobile) {
               // On regular mobile, use moderate increase
               containerWidthPercent = Math.max(containerWidthPercent, 650); // Increased from 600% to 650%
          }

          console.log('🎯 Container width calculation:', {
               cardCount,
               baseWidthMultiplier,
               containerWidthPercent: containerWidthPercent + '%',
               isMobile,
               isVerySmallMobile
          });

          console.log('🎯 Unified Timeline Controls:', {
               SCROLL_HEIGHT_BASE,
               SCROLL_HEIGHT_SCALE,
               PROGRESS_BASE,
               PROGRESS_SCALE,
               WIDTH_BASE,
               WIDTH_SCALE
          });
          console.log('🎬 Timeline calculations:', {
               cardCount,
               stickyHeight: (stickyHeight / window.innerHeight).toFixed(1) + 'vh',
               progressDivisor: progressDivisor.toFixed(3),
               containerWidthPercent: Math.round(containerWidthPercent) + '%',
               isMobile,
               isVerySmallMobile,
               mobileProgressAdjustment
          });

          // Set container width dynamically
          const cardsContainer = document.querySelector(".animated-timeline-cards");
          if (!cardsContainer) {
               console.error("❌ Cards container not found!");
               return;
          }
          
          // Add performance optimization
          cardsContainer.style.willChange = 'transform';
          
          // Kill existing ScrollTrigger if it exists
          if (currentScrollTrigger) {
               currentScrollTrigger.kill();
          }
          cardsContainer.style.width = containerWidthPercent + '%';

          // Kill existing ScrollTrigger if it exists
          if (currentScrollTrigger) {
               currentScrollTrigger.kill();
          }

          // Get header element for transparency effect (wait for it to be injected)
          let header = document.querySelector('.site-header');
          if (!header) {
               // Header might not be injected yet, wait a bit
               setTimeout(() => {
                    header = document.querySelector('.site-header');
                    console.log('🎭 Timeline Header Effect (delayed):', {
                         headerFound: !!header,
                         headerElement: header
                    });
               }, 100);
          } else {
               console.log('🎭 Timeline Header Effect:', {
                    headerFound: !!header,
                    headerElement: header
               });
          }

          console.log('🎯 Creating ScrollTrigger:', {
               trigger: stickySection,
               start: "top top",
               end: `+=${stickyHeight}px`,
               pin: true,
               stickyHeight,
               containerWidthPercent: Math.round(containerWidthPercent) + '%'
          });

          currentScrollTrigger = ScrollTrigger.create({
               trigger: stickySection,
               start: "top top",
               end: `+=${stickyHeight}px`,
               pin: true,
               onEnter: () => {
                    console.log('🎭 Timeline onEnter: Making header transparent');
                    // Get header again in case it wasn't available initially
                    const currentHeader = document.querySelector('.site-header') || header;
                    if (currentHeader) {
                         currentHeader.style.opacity = '0.1';
                         currentHeader.style.pointerEvents = 'none';
                         console.log('🎭 Header opacity set to 0.1');
                    } else {
                         console.log('🎭 Header not found in onEnter');
                    }
               },
               onLeave: () => {
                    console.log('🎭 Timeline onLeave: Restoring header');
                    const currentHeader = document.querySelector('.site-header') || header;
                    if (currentHeader) {
                         currentHeader.style.opacity = '';
                         currentHeader.style.pointerEvents = '';
                         console.log('🎭 Header opacity restored');
                    } else {
                         console.log('🎭 Header not found in onLeave');
                    }
               },
               onEnterBack: () => {
                    console.log('🎭 Timeline onEnterBack: Making header transparent');
                    const currentHeader = document.querySelector('.site-header') || header;
                    if (currentHeader) {
                         currentHeader.style.opacity = '0.1';
                         currentHeader.style.pointerEvents = 'none';
                         console.log('🎭 Header opacity set to 0.1 (back)');
                    } else {
                         console.log('🎭 Header not found in onEnterBack');
                    }
               },
               onLeaveBack: () => {
                    console.log('🎭 Timeline onLeaveBack: Restoring header');
                    const currentHeader = document.querySelector('.site-header') || header;
                    if (currentHeader) {
                         currentHeader.style.opacity = '';
                         currentHeader.style.pointerEvents = '';
                         console.log('🎭 Header opacity restored (back)');
                    } else {
                         console.log('🎭 Header not found in onLeaveBack');
                    }
               },
               onUpdate: (self) => {
                    canvasXPosition = -self.progress * 200;
                    drawGrid(self.progress);

                    // Match Salon des Rêves movement calculation
                    const progress = Math.min(self.progress / progressDivisor, 1);
                    const movement = progress * (cardsContainer.scrollWidth - window.innerWidth);
                    
                    // Use gsap.set for immediate positioning without animation
                    gsap.set(cardsContainer, {
                        x: -movement
                    });
               },
          });
     }

     initializeTriangles();
     drawGrid();
     initTimeline();

     window.addEventListener("resize", () => {
          // Debounce resize to avoid excessive recreation
          clearTimeout(window.timelineLereveResizeTimeout);
          window.timelineLereveResizeTimeout = setTimeout(() => {
               setCanvasSize(outlineCanvas, outlineCtx);
               setCanvasSize(fillCanvas, fillCtx);
               triangleStates.clear();
               initializeTriangles();
               drawGrid();
               initTimeline();
          }, 250);
     });
     
     // Initial setup
     if (document.readyState === 'complete' || document.readyState === 'interactive') {
          // If the document is already loaded, initialize immediately
          setTimeout(initTimeline, 1);
     }
});
